import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { Button, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import { withTranslation } from "react-i18next"
import toastr from "toastr"
import { apiEditarDispositivo } from "../../helpers/backend_helper"

const DispositivoEditarModal = props => {
  const { t, isOpen, dispositivo, onClose, onSaved } = props
  const [numeroMesa, setNumeroMesa] = useState("")
  const [salvando, setSalvando] = useState(false)

  useEffect(() => {
    if (isOpen) {
      setNumeroMesa(dispositivo?.numero_mesa != null ? String(dispositivo.numero_mesa) : "")
    }
  }, [isOpen, dispositivo])

  const salvar = async () => {
    if (!dispositivo?.id) return
    setSalvando(true)
    const parsed = numeroMesa === "" ? null : parseInt(numeroMesa, 10)
    try {
      // necessário enviar os campos imei, versao_app e id_usuario para atualizar o dispositivo devido o serviço put validar estes campos devido o aplicativo
      await apiEditarDispositivo({ id: dispositivo.id, numero_mesa: parsed, id_usuario: dispositivo.id_usuario, imei: dispositivo.imei, versao_app: dispositivo.versao_app })
      swal({ title: "Alteração realizado com sucesso!", icon: "success" }).then()
      onSaved()
      onClose()
    } catch (error) {
      swal({
        title: "Gerou erro ao excluir o dispositivo!",
        icon: "error",
        text: error?.response?.data?.message ? error?.response?.data?.message : error?.response?.data
      }).then()
    } finally {
      setSalvando(false)
    }
  }

  return (
    <Modal isOpen={ isOpen } toggle={ onClose } centered>
      <ModalHeader toggle={ onClose }>
        { t("cardapio.dispositivo.editar.titulo") }
      </ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label for="dispositivo-numero-mesa">
              { t("cardapio.dispositivo.editar.numeromesa.label") }
            </Label>
            <Input
              id="dispositivo-numero-mesa"
              type="number"
              min="0"
              value={ numeroMesa }
              onChange={ e => setNumeroMesa(e.target.value) }
            />
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={ salvar } disabled={ salvando }>
          { t("cardapio.dispositivo.editar.botao.salvar") }
        </Button>
        <Button color="secondary" onClick={ onClose } disabled={ salvando }>
          { t("cardapio.dispositivo.editar.botao.cancelar") }
        </Button>
      </ModalFooter>
    </Modal>
  )
}

DispositivoEditarModal.propTypes = {
  t: PropTypes.func,
  isOpen: PropTypes.bool.isRequired,
  dispositivo: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onSaved: PropTypes.func.isRequired
}

export default withTranslation()(DispositivoEditarModal)
